import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { UpdatePreferencesRequest } from './types/update-preferences-request.type';
import type { UserPreferences } from './types/user-preferences.type';

/**
 * Replaces the current user's preferences blob.
 *
 * The server overwrites the entire JSON column — clients must merge their
 * delta into the latest known preferences object before calling this. See
 * `useSetPreference` for the merge helper.
 *
 * @param instance - Ky HTTP instance.
 * @param body - Full preferences payload.
 * @returns OperationResultWithData wrapping the persisted blob.
 */
export const updatePreferences = async (instance: KyInstance, body: UpdatePreferencesRequest) => {
  try {
    return await instance
      .put<OperationResultWithData<UserPreferences>>(Uri.preferences.base, {
        json: body,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
